import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Get token from sessionStorage
const getToken = () => {
  const storedUser = sessionStorage.getItem("userElqma");
  if (!storedUser) {
    throw new Error('No authentication token found');
  }
  
  const parsedUser = JSON.parse(storedUser);
  const token = parsedUser?.token || parsedUser?.data?.token || parsedUser?.user?.token;
  
  if (!token) {
    throw new Error('No authentication token found');
  }
  
  return token;
};

// Fetch settings
export const fetchSettings = createAsyncThunk(
  'settings/fetchSettings',
  async (_, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(`${BASE_URL}/dashboard/setting`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// Update settings
export const updateSettings = createAsyncThunk(
  'settings/updateSettings',
  async (settingsData, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.post(`${BASE_URL}/dashboard/setting`, settingsData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  settings: null,
  isLoading: false,
  error: null,
  success: null,
  updateLoading: false
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch settings
      .addCase(fetchSettings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settings = action.payload.data;
        state.error = null;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || 'حدث خطأ في تحميل الإعدادات';
      })
      
      // Update settings
      .addCase(updateSettings.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.settings = action.payload.data;
        state.success = action.payload.message || 'تم تحديث الإعدادات بنجاح';
        state.error = null;
      })
      .addCase(updateSettings.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload?.message || action.payload || 'حدث خطأ في تحديث الإعدادات';
        state.success = null;
      });
  },
});

export const { clearState } = settingsSlice.actions;
export default settingsSlice.reducer;